const state = () => {
  const result = []

  let characters = 'abcdefghijklmnopqrstuvwxyz'
  characters += '0123456789'
  characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  characters += '$%^&)><?"@'

  for (let i = 0; i < 8; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * characters.length))
    )
  }

  return result.join('')
}

export default state
